import {
  Dictionary,
  IDictionaryQueryOptions,
  IDictionaryFindByCodeOptions,
  IDictionaryFindByDataOptions,
} from '@toy/v-use';

const dictionary = new Dictionary({
  apiOptions: {
    consumerCode: 'AIAP',
  },
});

/**
 * 异步获取字典选项数据
 * @param key 字典编码，用于标识特定的字典数据
 * @param data 字典查询选项，可包含层级限制等查询条件
 * @returns 返回Promise类型的字典数据结果
 */
export const getDictionaryOptions = (key: string, data?: IDictionaryQueryOptions) => {
  return dictionary.get(key, data);
};

/**
 * 同步获取字典选项数据（注：实际实现与异步方法相同）
 * @param key 字典编码，用于标识特定的字典数据
 * @param data 字典查询选项，可包含层级限制等查询条件
 * @returns 返回Promise类型的字典数据结果
 */
export const getDictionaryOptionsSync = (key: string, data?: IDictionaryQueryOptions) => {
  return dictionary.getSync(key, data);
};

/**
 * 批量同步获取字典选项数据
 * @param keys 字典编码数组，用于标识多个特定的字典数据
 * @param data 字典查询选项，可包含层级限制等查询条件
 * @returns 返回Promise类型的批量字典数据结果
 */
export const batchDictionaryOptionsSync = (keys: string[], data?: IDictionaryQueryOptions) => {
  return dictionary.batchSync(keys, data);
};

/**
 * 根据字典编码在指定字典中查找数据
 * @param codes 需要查找的字典项编码数组
 * @param data 查找配置选项
 * @param data.dictCode 目标字典的编码，指定在哪个字典中进行查找
 * @param data.deep 是否深度查询子级数据，true表示递归查找所有层级的子数据
 * @returns 返回匹配的字典项数据数组
 */
export const findByCodeDictionarySync = (codes: string[], data: IDictionaryFindByCodeOptions) => {
  return dictionary.findByCode(codes, data);
};

/**
 * 在给定的字典数据中根据编码查找数据
 * @param codes 需要查找的字典项编码数组
 * @param sourceData 查找配置选项
 * @param sourceData.dictData 用于查询的字典数据源，这是一个已经获取到的字典数据数组
 * @param sourceData.deep 是否深度查询子级数据，true表示递归查找所有层级的子数据
 * @returns 返回匹配的字典项数据数组
 */
export const findByDataDictionary = (codes: string[], sourceData: IDictionaryFindByDataOptions) => {
  return dictionary.findByData(codes, sourceData);
};
